import { Capacitor } from '@capacitor/core';

export function getPlatform() {
  return Capacitor.getPlatform();
}

export function isNative() {
  return Capacitor.isNativePlatform();
}

export function isIOS() {
  return Capacitor.getPlatform() === 'ios';
}

export function isAndroid() {
  return Capacitor.getPlatform() === 'android';
}

export function isWeb() {
  return Capacitor.getPlatform() === 'web';
}

// Stripe checkout has been removed — Apple IAP is the only supported payment path.
export function canShowStripeCheckout() {
  return false;
}

export function canShowAppleIAP() {
  return isIOS();
}
